Vendd.Scripts.load(function () {

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    var ageVerificationPopUp = $('.x-age-verification-popup');
    var ageCookie = Cookies.get('aboveAge');

    var $wrapper = $('.x-newsletter-popup');

    if ($wrapper.length < 1 || !funcCookiesEnabled || (ageVerificationPopUp.length > 0 && (!ageCookie || typeof ageCookie === "undefined" )))
        return;

    InitPromoPopUp();

    function InitPromoPopUp() {
        var cookiesAccepted = window.ConsentsManager.cookiesStatus.userHasSetCookies;
        var promo = Cookies.get('promo');

        if (!promo && cookiesAccepted && $('.terms-page.consents-page').length <=0) {
            if (!isTouch()) {
                $(".open-fancy-promo", $wrapper).fancybox({
                    margin: [20, 0],
                    modal: true,
                    afterClose: function () {
                        Cookies.set("promo", true, { expires: 5, samesite: 'Lax' });
                    }
                });
                $(".open-fancy-promo", $wrapper).trigger("click");
                $('.newsletter-popup .close-button').click(function () {
                    $.fancybox.close(true);
                });
            } else {
                setTimeout(function () {
                    $('.fancy-promo-container').show().addClass('shown');
                }, 2500);
                $('.newsletter-popup .close-button').click(function () {
                    $('.fancy-promo-container').hide().removeClass('shown');
                    Cookies.set("promo", true, { expires: 5, samesite: 'Lax' });
                });
            }
        }
    }
});
